export const isInCypress = () => !!window.Cypress;
